import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"
import {
  acknowledgeLifecycleActivation,
  lifecycleActivation
} from "./lifecycle_activation_acceptance"

export default class extends Controller {
  static values = {
    title: String,
    url: String
  }

  connect() {
    this.acceptedLifecycleIntentId ??= null
    this.visitStarted ??= false

    if (this.hasTitleValue) document.title = this.titleValue
  }

  activate(event) {
    const activation = lifecycleActivation(event, this.acceptedLifecycleIntentId)
    if (!activation) return

    acknowledgeLifecycleActivation(this, activation)
    if (this.visitStarted) return

    this.visitStarted = true
    visit(this.urlValue, { action: "replace" })
  }
}
